module.exports = __webpack_public_path__ + "img/item_image03.598c2047.jpg";